import { DataGetter, TealiumData, Utag } from "../types";
import { getViewData, trackView } from "./trackView";
import { trackEvent } from "./trackEvent";
import { trackViewData } from "./viewDataDispatcher";
import { debugLog } from "./debugLog";

let trackViewPromiseResolver: (viewDataGetters: Array<DataGetter>) => void;

let trackViewPromise: Promise<Array<DataGetter>> = new Promise((resolve) => {
  trackViewPromiseResolver = resolve;
});

export const freezeNonUserDataGetters = (
  dataGetters: Array<DataGetter>,
): Array<DataGetter> =>
  dataGetters.map((dataGetter) => {
    const data = dataGetter();
    if ("user" in data) {
      return dataGetter;
    } else {
      return (): TealiumData => data;
    }
  });

export const trackViewSequentially = (
  getUtag: () => Promise<Utag>,
  viewDataGetters: Array<DataGetter>,
): Promise<void> => {
  const frozenViewDataGetters = freezeNonUserDataGetters(viewDataGetters);
  const viewData = getViewData(frozenViewDataGetters);
  trackViewData(viewData);
  const promise = trackView(getUtag, viewData);
  trackViewPromiseResolver(frozenViewDataGetters);
  return promise;
};

export const trackEventSequentially = async (
  getUtag: () => Promise<Utag>,
  eventDataGetter: DataGetter,
  additionalViewDataGetters: Array<DataGetter> = [() => ({})],
): Promise<void> => {
  const viewDataGetters = await trackViewPromise;
  const viewData = getViewData(viewDataGetters);
  const additionalViewData = getViewData(additionalViewDataGetters);
  return trackEvent(
    getUtag,
    { ...viewData, ...additionalViewData },
    eventDataGetter,
  );
};

export const clearView = (): void => {
  debugLog("Clearing view data.");
  trackViewPromise = new Promise((resolve) => {
    trackViewPromiseResolver = resolve;
  });
};
